import {DEFAULT_FREE_LIME_CONFIG} from '../common/constants'
import {FreeLimeConfig} from '../declarations'

import {usePlant} from './usePlant'

export const useFreeLimeConfig: () => FreeLimeConfig = () => {
  const plant = usePlant()
  return plant?.freeLimeConfig ?? DEFAULT_FREE_LIME_CONFIG
}
